import useQuery from './useQuery';
import { PlanApiResponse } from '../../modules/features/typings';
import { fetchCurrentPlan } from '../../modules/features/requests';
import { getAllPlansAtom } from '../../modules/features/state';
import { useCallback, useEffect, useRef } from 'react';
import { useAtomValue } from 'jotai';

const useCurrentPlan = () => {
  const getAllPlansAtomValue = useAtomValue(getAllPlansAtom);

  const {
    requestData: { data, loading },
    fetchData,
  } = useQuery<PlanApiResponse>({
    requestAtom: getAllPlansAtom,
    queryFunction: fetchCurrentPlan,
    autoFetch: false,
  });

  useEffect(() => {
    const getSetCurrentPlan = async () => {
      if (!getAllPlansAtomValue?.data && !loading) {
        await fetchData?.();
      }
    };
    getSetCurrentPlan();
  }, [getAllPlansAtomValue?.data, loading]);

  const currentPlan = getAllPlansAtomValue?.data?.plans.find(
    ({ planId }) => planId === getAllPlansAtomValue?.data?.currentPlan
  );
  return {
    availableFeatures: currentPlan?.features || [],
    currentPlan: currentPlan?.planId,
    loading,
  };
};

export default useCurrentPlan;
